import { render } from "./Radiology.vue?vue&type=template&id=60ca3af5&scoped=true"
import script from "./Radiology.vue?vue&type=script&lang=ts"
export * from "./Radiology.vue?vue&type=script&lang=ts"

import "./Radiology.vue?vue&type=style&index=0&id=60ca3af5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-60ca3af5"

export default script